import React, { Component } from "react";
import HeaderLinks from "../Header/HeaderLinks.jsx";
import { connect } from "react-redux";
//import sideNav from "./SidebarNav";
import { FiChevronDown } from "react-icons/fi";
import { AiOutlineClose } from "react-icons/ai";
import $ from "jquery";
import { Link } from "react-router-dom";
import { settingsActions } from "../../../redux/actions/settings-actions.jsx";
//import { helperFunctions as HF } from "../../../helper/helperFunctions";
import { withRouter } from "react-router-dom";
import { adminUserActions } from "../../../redux/actions/admin-user-action";

class SidebarPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            width: window.innerWidth,
            dashboardName: "GTV",
            iconHeight: "20px",
            iconWidth: "20px",
            list_types: []
        };

        // this.OpenDropDown = this.OpenDropDown.bind(this);
        this.activeRoute = this.activeRoute.bind(this);
        this.createUl = this.createUl.bind(this);
        this.createLi = this.createLi.bind(this);
    }

    onClick = () => {};
    createLi(menu_id, menu, key) {
        if (typeof menu["parent_labels"][menu_id] === "undefined") {
            return (
                <li
                    id={"id-" + menu_id}
                    className={this.activeRoute(
                        menu["permissions"][menu_id]["path"],
                        menu_id
                    )}
                    key={key}
                >
                    <span className="nav-link">
                        <Link
                            to={
                                menu["permissions"][menu_id]["path"] != null
                                    ? menu["permissions"][menu_id]["path"]
                                    : ""
                            }
                        >
                            {menu["permissions"][menu_id]["icon"] != null && (
                                <img
                                    alt="logo_image"
                                    src={require("../../../assets/img/sideNav/" +
                                        menu["permissions"][menu_id]["icon"])}
                                    className="imgIconMarRight"
                                />
                            )}
                            {menu["permissions"][menu_id]["label"]}
                        </Link>
                    </span>
                </li>
            );
        } else if (typeof menu["parent_labels"][menu_id] !== "undefined") {
            return (
                <li id={"id-" + menu_id} className="hasChildNav" key={key}>
                    <span className="nav-link">
                        <a
                            href={"#id" + menu_id}
                            data-toggle="collapse"
                            aria-expanded="false"
                            className="dropdown-toggle collapsed"
                        >
                            {menu["permissions"][menu_id]["icon"] != null && (
                                <img
                                    alt="logo_image"
                                    src={require("../../../assets/img/sideNav/" +
                                        menu["permissions"][menu_id]["icon"])}
                                    className="imgIconMarRight"
                                />
                            )}
                            {menu["permissions"][menu_id]["label"]}
                            <FiChevronDown />
                        </a>
                    </span>
                    {this.createUl(
                        menu_id,
                        menu,
                        "list-unstyled sideChildNav collapse"
                    )}
                </li>
            );
        }
    }

    createUl(parent, menu, ulClass) {
        if (typeof menu["parent_labels"][parent] !== "undefined") {
            const menuId = "id" + parent;
            return ulClass === "list-unstyled sideChildNav collapse" ? (
                <ul id={menuId} className={ulClass}>
                    {menu["parent_labels"][parent].map((menu_id, key) => {
                        return this.createLi(menu_id, menu, key);
                    })}
                </ul>
            ) : (
                <ul className={ulClass}>
                    {menu["parent_labels"][parent].map((menu_id, key) => {
                        return this.createLi(menu_id, menu, key);
                    })}
                </ul>
            );
        }
    }
    // OpenDropDown(id) {
    //     var sub_height;
    //     if ($("#" + id).hasClass("openSubMenu")) {
    //         $("#" + id + " span")
    //             .first()
    //             .removeClass("collapsed");
    //         $("#" + id + " ul")
    //             .first()
    //             .addClass("in", 2000);
    //         $("#" + id).removeClass("openSubMenu");
    //         sub_height = $(".sidebar").outerWidth();
    //         $(".main-panel").css({
    //             width: "calc(100% - " + sub_height + "px)"
    //         });
    //     } else {
    //         $("#" + id).addClass("openSubMenu");
    //         $("#" + id + " span")
    //             .first()
    //             .addClass("collapsed");
    //         $("#" + id + " ul")
    //             .first()
    //             .removeClass("in", 1000);
    //         sub_height = $(".sidebar").outerWidth();
    //         $(".main-panel").css({
    //             width: "calc(100% - " + sub_height + "px)"
    //         });
    //     }
    // }
    activeRoute(routeName, menu_id) {
        var dashboardMenuTemp = this.props.menu;
        if (
            typeof dashboardMenuTemp["parent_labels"][menu_id] !== "undefined"
        ) {
            return this.props.location.pathname.indexOf(routeName) > -1
                ? "active noChild"
                : "";
        } else if (
            typeof dashboardMenuTemp["parent_labels"][menu_id] === "undefined"
        ) {
            if (
                dashboardMenuTemp["permissions"][menu_id]["parent_label"] === 0
            ) {
                return this.props.location.pathname.indexOf(routeName) > -1
                    ? "lastChild "
                    : "";
            } else {
                return this.props.location.pathname.indexOf(routeName) > -1
                    ? "active hasParent "
                    : "";
            }
        }
    }
    updateDimensions() {
        this.setState({ width: window.innerWidth });
    }
    componentDidMount() {
        var checkLogin = localStorage.getItem("user");
        if (checkLogin) {
            this.props.getMenuCall();
            //this.OnLoadIfOpenSubMenu();
        }
    }
    componentDidUpdate(prevProps) {
        this.OnLoadIfOpenSubMenu();
    }
    OnLoadIfOpenSubMenu() {
        $("li.active")
            .parents("li")
            .addClass("openSubMenu");
    }

    // genMenus = (navItem, index) => {
    //     const uniqueId = nextId();
    //     return navItem.hasChildNav
    //         ? HF.checkRoleAndDisplayMenu(navItem.displayForRoles) && (
    //               <li key={index}>
    //                   <span className="nav-link hasChildNav">
    //                       <img src={navItem.icon} className="imgIconMarRight" />
    //                       <a
    //                           href={"#" + uniqueId}
    //                           data-toggle="collapse"
    //                           aria-expanded="false"
    //                           className="dropdown-toggle collapsed"
    //                       >
    //                           {navItem.name}
    //                           <FiChevronDown />
    //                       </a>
    //                   </span>
    //                   <ul
    //                       className="list-unstyled sideChildNav collapse"
    //                       id={uniqueId}
    //                       aria-expanded="false"
    //                   >
    //                       {navItem.childNav.map((childItem, index) => {
    //                           return childItem.hasChildNav
    //                               ? this.genMenus(childItem, index)
    //                               : HF.checkRoleAndDisplayMenu(
    //                                     childItem.displayForRoles
    //                                 ) && (
    //                                     <li key={index}>
    //                                         <span className="nav-link">
    //                                             <img
    //                                                 src={childItem.icon}
    //                                                 className="imgIconMarRight"
    //                                             />
    //                                             <Link to={childItem.path}>
    //                                                 {childItem.name}
    //                                             </Link>
    //                                         </span>
    //                                     </li>
    //                                 );
    //                       })}
    //                   </ul>
    //               </li>
    //           )
    //         : HF.checkRoleAndDisplayMenu(navItem.displayForRoles) && (
    //               <li key={index}>
    //                   <span className="nav-link">
    //                       <img src={navItem.icon} className="imgIconMarRight" />
    //                       <Link to={navItem.path}>{navItem.name}</Link>
    //                   </span>
    //               </li>
    //           );
    // };

    render() {
        // const { menu} = this.props;
        const { menu } = this.props;

        return (
            <div id="sidebar" onMouseEnter={this.props.canvasMenuToggle ? null : this.props.showSideMenu} onMouseLeave={this.props.hideCanvasMenu} className="sidebar">
                <div className="closeBtn">
                    <button onClick={this.props.toggleMenu}><AiOutlineClose /></button>
                </div>
                <div className="sidebar-wrapper">
                    {this.state.width <= 991 ? <HeaderLinks /> : null}
                    {typeof menu !== "undefined" &&
                        Object.keys(menu["parent_labels"]).length > 0 &&
                        this.createUl(0, menu, "nav")}
                    {/* <ul className="nav">
                        {sideNav.map((item, index) => {
                            return this.genMenus(item, index);
                        })}
                    </ul> */}
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getMenuCall: () => {
            dispatch(adminUserActions.dashboardMenu());
        },
        getListTypesCall: () => {
            dispatch(settingsActions.getListTypes());
        }
    };
};

function mapStateToProps(state) {
    const { userAdmin, menu, loading } = state.adminReducer;

    const { list_types } = state.settingsReducer;
    return {
        userAdmin,
        menu,
        loading,
        list_types
    };
}

const Sidebar = withRouter(
    connect(mapStateToProps, mapDispatchToProps)(SidebarPage)
);
export default Sidebar;



// WEBPACK FOOTER //
// ./src/components/Admin/Sidebar/Sidebar.jsx